import type { FeatureFlagEnvironment } from '@arritech/shared/feature-flags';

const viteEnv = import.meta.env as Record<string, string | undefined>;
const globalProcess = (
	globalThis as typeof globalThis & {
		process?: { env?: Record<string, string | undefined> };
	}
).process;
const buildEnv = globalProcess?.env ?? {};

const resolveEnv = (key: string, legacyKey = key) =>
	viteEnv[key] ||
	viteEnv[legacyKey] ||
	buildEnv[key] ||
	buildEnv[legacyKey] ||
	'';

export const baseDomain = resolveEnv(
	'VITE_DWAYRA_GATEWAY_URL',
	'VUE_APP_DWAYRA_GATEWAY_URL'
);
export const environment = resolveEnv(
	'VITE_DWAYRA_ENVIRONMENT',
	'VUE_APP_DWAYRA_ENVIRONMENT'
);
export const isLocalGateway = baseDomain?.includes('localhost') || false;
export const cacheExpireTime = new Date().getTime() + 7 * 24 * 60 * 60 * 1000;
export const newInfra = resolveEnv(
	'VITE_DWAYRA_NEW_INFRA',
	'VUE_APP_NEW_INFRA'
);
export const maintenanceEnv = resolveEnv(
	'VITE_IS_MAINTENANCE',
	'VUE_APP_IS_MAINTENANCE'
);
export const disableLogsEnv = resolveEnv(
	'VITE_DWAYRA_DISABLE_LOGS',
	'VUE_APP_DWAYRA_DISABLE_LOGS'
);
export const sentry = resolveEnv('VITE_SENTRY_DSN', 'VUE_APP_SENTRY_DSN');

/**
 * thanos_cms, where release notes are written.
 *
 * This app has no server of its own, so the browser reaches the CMS directly —
 * which means the CMS has to list this app's origin in CORS_ORIGINS. Empty
 * turns the release notes screen into its empty state rather than failing.
 */
export const cmsUrl = resolveEnv('VITE_CMS_URL', 'VUE_APP_CMS_URL');

export const isDev = () => environment === 'dev';
export const isProd = () => environment === 'prod';

export const featureFlagEnvironment: FeatureFlagEnvironment =
	environment === 'prod'
		? 'production'
		: environment === 'dev'
			? 'dev'
			: 'local';

const config = {
	environment,
	baseDomain,
	isLocalGateway,
	cacheExpireTime,
	newInfra,
	maintenanceEnv,
	disableLogsEnv,
	sentry,
	cmsUrl,
	featureFlagEnvironment,
};
export default config;
